import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { SecondaryLink } from '../../components/ClickableComponents/Link';
import { SmartLink } from '../../components/ClickableComponents/SmartLink';
import { PlayImage } from '../../components/Image/PlayImage';
import { PlayContainer } from '../../components/PlayContainer/PlayContainer';
import { usePath } from '../../config/VideoAppContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaSectionWithShowDetailHeader = ({
  sectionDetail
}) => {
  const {
    t
  } = useTranslation();
  const {
    show
  } = sectionDetail.data;
  const {
    videoShowPath
  } = usePath();
  const {
    representation: {
      title,
      description
    }
  } = sectionDetail;
  return /*#__PURE__*/_jsx(PlayContainer, {
    children: /*#__PURE__*/_jsxs(Layout, {
      children: [/*#__PURE__*/_jsx(SmartLink, {
        to: videoShowPath(show),
        isInternal: true,
        children: /*#__PURE__*/_jsx(Image, {
          children: /*#__PURE__*/_jsx(PlayImage, {
            aspectRatio: '16/9',
            src: show.imageUrl,
            width: 480,
            alt: show.title
          })
        })
      }), /*#__PURE__*/_jsxs("section", {
        children: [/*#__PURE__*/_jsx(Title, {
          children: title
        }), description && /*#__PURE__*/_jsx(Description, {
          children: description
        }), (title || description) && /*#__PURE__*/_jsx(ShowLink, {
          type: "text",
          text: t('global.moreFrom', {
            showName: show.title
          }),
          to: videoShowPath(show),
          isInternal: true,
          showDefaultIcon: true
        })]
      })]
    })
  });
};
const Layout = styled.div.withConfig({
  displayName: "MediaSectionWithShowDetailHeader__Layout",
  componentId: "sc-vzodhb-0"
})(["display:grid;grid-gap:16px;", "{margin-top:16px;grid-template-columns:32% minmax(0,1fr);}", "{margin-top:32px;grid-gap:40px;grid-template-columns:32.5% minmax(0,1fr);}", "{grid-gap:32px;grid-template-columns:24.2% minmax(0,1fr);}"], Viewports.for('mediumUp'), Viewports.for('largeUp'), Viewports.for('xLargeUp'));
const Image = styled.div.withConfig({
  displayName: "MediaSectionWithShowDetailHeader__Image",
  componentId: "sc-vzodhb-1"
})(["", "{margin-left:-16px;margin-right:-16px;}"], Viewports.for('small'));
export const Title = styled.h1.withConfig({
  displayName: "MediaSectionWithShowDetailHeader__Title",
  componentId: "sc-vzodhb-2"
})(["color:", ";", ";margin-top:0;margin-bottom:0;"], Colors.WHITE, Fonts.bold(34));
export const Description = styled.p.withConfig({
  displayName: "MediaSectionWithShowDetailHeader__Description",
  componentId: "sc-vzodhb-3"
})(["color:", ";margin-top:16px;margin-bottom:0;max-width:1024px;", ";line-height:26px;", "{margin-top:8px;}"], Colors.WHITE, Fonts.light(18), Viewports.for('medium'));
const ShowLink = styled(SecondaryLink).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "MediaSectionWithShowDetailHeader__ShowLink",
  componentId: "sc-vzodhb-4"
})(["margin-top:16px;", "{display:inline-flex;}", "{margin-top:24px;}", "{margin-top:32px;}"], Viewports.for('mediumUp'), Viewports.for('large'), Viewports.for('xLargeUp'));